import { useMutation } from '@tanstack/react-query';
import { reserveTimeSlot } from '@services/cpqService';
import type { SlotReservationRequest, SlotReservationResponse } from '@t/checkout.types';

interface UseReserveSlotOptions {
  onSuccess?: (data: SlotReservationResponse) => void;
  onError?: (error: Error) => void;
}

export const useReserveSlot = (sessionId: string, { onSuccess, onError }: UseReserveSlotOptions = {}) => {
  const mutation = useMutation<SlotReservationResponse, Error, SlotReservationRequest>({
    mutationFn: (payload) => reserveTimeSlot(sessionId, payload),
    onSuccess,
    onError,
  });

  return {
    reserve: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
